import styles from './Home.module.css';

export default function Home() {
    return (
        <section className={styles.Homepage} id='home'>
            <section className={styles.TextContent}>
                
                <p className={styles.boldText}>Learn, Grow and Excel</p>
         
                <p className={styles.regularText}>
                We are committed to providing a nurturing environment where students explore their potential,
                    embrace learning, and achieve excellence.
                </p>
                
                <a href='#about-us' about="K P Jadhav High School & Junior College">Learn more</a>
            </section>
            <section className={styles.heroImage}>
                <img src='/home.webp' alt='Student studying at K P Jadhav High School & Junior College' loading='eager' />
            </section>
           
        </section>
    )
}